import { render, staticRenderFns } from "./attrs.vue?vue&type=template&id=993badb0&scoped=true"
import script from "./attrs.vue?vue&type=script&lang=ts"
export * from "./attrs.vue?vue&type=script&lang=ts"
import style0 from "./attrs.vue?vue&type=style&index=0&id=993badb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993badb0",
  null
  
)

export default component.exports